import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const SUBSCRIPTION_OFFER_WITHDRAW = gql(`
  mutation subscriptionOfferWithdraw($subscriptionOfferId: ID!) {
    subscriptionOfferWithdraw(subscriptionOfferId: $subscriptionOfferId) {
      ... on SubscriptionOffer {
        __typename
        id
        status
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
      ... on SubscriptionOfferInvalidStatus {
        __typename
        id
      }
    }
  }
`);

export function useSubscriptionOfferWithdraw(subscriptionOfferId: string) {
  return useMutation(SUBSCRIPTION_OFFER_WITHDRAW, {
    variables: {
      subscriptionOfferId
    }
  });
}
